<template>
	<div class="sub-tree" :style="{'height': compHeight}">
		<sub-table ref="table" v-model="rootList" height="auto" :paging="false">
			<sub-table-column
				type="expand"
				label="节点"
				:expand-button="notLeaf"
				:add-button="false"
				@expand="loadChildren"
			>
				<template v-slot="row">
					<div class="node flex-center-cross" :class="{'z-crt': current && current.data.id == row.data.id}" @click="selectNode(row)">
						<i class="tf">&#xe67b;</i>
						<span>{{row.data[props.name || 'name']}}</span>
					</div>
				</template>
			</sub-table-column>
		</sub-table>
	</div>
</template>

<script>
	export default {
		props: {
			props: {
				type: Object,
				default: () => {
					return {};
				}
			},
			
			height: [String, Number],
			
			load: {
				type: Function,
				default: function() {}
			},
			
			leading: {
				type: Boolean,
				default: true
			}
		},

		data() {
			return {
				rootList: [],
				current: ''
			}
		},
		
		computed: {
			compHeight() {
				return `${parseInt(this.height)}px`;
			}
		},
		
		mounted() {
			this.leading && this.update();
		},

		methods: {
			notLeaf(row) {
				return !row.data.leaf;
			},
			
			update() {
				this.load(undefined, data => {
					this.current = '';
					this.rootList = data;
				});
			},
			
			loadChildren(row, resolve) {
				this.load(row, resolve);
			},
			
			selectNode(row) {
				this.current = row;
				row && this.$emit('node-click', row);
			},
			
			getNode(filter = 'all') {
				if (filter == 'selected') {
					return this.current;
				} else {
					return this.$refs.table.getRow(filter);
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.sub-tree {
		padding: 10px 0;
		
		>>> .sub-table {
			table {
				width: initial;
				min-width: 100% !important;
			}
			
			&-body {
				overflow: initial;
			}
			
			&-head-wrapper {
				display: none;
			}
			
			&-body-wrapper {
				overflow: initial;
			}
			
			tr {
				background: none !important;
				
				&:hover {
					background: #eee !important;
				}
			
				td {
					border: none;
					padding: 4px 8px;
					
					.node {
						display: inline-block;
						padding: 0 4px;
						border: 1px solid rgba(0,0,0,0);
						white-space: nowrap;
						cursor: pointer;
						
						&.z-crt {
							border-color: #FFB951;
							padding: 0 4px;
							background: #FFE6B0;
						}
						
						.tf {
							margin-right: 5px;
							font-size: 15px;
							color: #e6c779;
						}
					}
				}
			}
		}
	}
</style>
